import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../CuppingTherapyTreatment/CuppingTherapyTreatment.css";
import CupImg from "../IMG/laser-epilation-hair-removal-therapy.jpg";
import BookingComponent from "../BookNow/BookNowCall";
import SEO from "../../../SEO";
import "./WaxingServices.css";
const WaxingServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cupping-page-wrapper">
      <SEO
        title="Full Body Waxing | Men's Waxing | Women's Waxing"
        description="Experience the best Full Body Waxing at Shrikrishna Arogyam for both men and women in Pune. We offer affordable men's waxing and women's waxing services."
        keywords="Full Body Waxing , Men's Waxing , Women's Waxing"
        canonical="https://shrikrishnaarogyammassagestherapy.com/full-body-waxing"
      />
      {/* Animated Header */}
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="cupping-header"
      >
        <h1>
          Smooth, Clean, and Confident: Feel Your Best with Our Full Body Waxing{" "}
        </h1>
      </motion.header>

      <Container className="cupping-content">
        <Row className="cupping-section">
          <Col md={6} className="cupping-image-col">
            <motion.img
              src={CupImg}
              alt="Cupping Therapy"
              className="cupping-image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
            />
          </Col>
          <Col md={6} className="cupping-text-col">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              className="cupping-description waxing-description"
            >
              Everyone wants skin that feels soft, smooth, and fresh, and only
              we at <b>Shrikrishna Arogyam Massage Therapy</b> have the best and
              most perfect approach to <b>Full Body Waxing</b>. Our trained
              professionals use high-quality products to ensure a safe,
              hygienic, and nearly painless experience every time. waxing
              services for both men and women gets you ready for a special event
              or just wanting to feel neat every day. Our body waxing service
              thus helps you look and feel great and is trusted by clients
              across Karve Nagar, Deccan, Kothrud, Baner, Balewadi, Aundh, and
              Panchvati in Pune.
            </motion.p>
          </Col>
        </Row>

        <h2 className="hiw">What is meant by Full Body Waxing?</h2>

        <Card className="cupping-card">
          <Card.Body>
            <Card.Text>
              It is the entire process and procedure by which hair from all
              areas of your body where it grows, including arms and legs, the
              underarms, back, chest, stomach, and also intimate areas, is
              removed using wax. The process makes the area being treated look
              clean, healthy and hygienic. It also slows down hair growth,
              besides making it finer (as opposed to coarse hair) over time.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="cupping-card">
          <Card.Body>
            <Card.Text>
              Where we score over others is with our trained team and use of the
              best quality ingredients, including high-quality, best-in-class
              wax that is gentle on the skin. Besides these, our process follows
              strict hygiene rules to make sure visitors feel comfortable,
              relaxed and disease-free at all times.
            </Card.Text>
          </Card.Body>
        </Card>

        <h2>How is Waxing Better than Shaving?</h2>

        <ul className="cupping-benefitssssssssss">
          <p>Waxing is better than shaving in quite a few respects, namely:</p>
          <li>
            Removal of hair from its roots, and not cutting it off from the
            visible surface
          </li>
          <li>
            Keeps your skin smoother for extended periods of time (3 to 6 weeks)
          </li>
          <li>
            Does not bring about skin cuts, razor burns, and bumps, all of which
            are normal under shaving.
          </li>
          <li>Hair that grows back appears thinner and softer</li>
          <li>While gently removing a layer of dead skin, it brings a glow</li>
          <p>
            Many people also say waxing gives them a boost of confidence, the
            direct result of clear skin that makes one feel fresh, clean and
            confident.
          </p>
        </ul>

        <h2>Services for both Men and Women!</h2>
        <p>
          At <b>Shrikrishna Arogyam</b>, we offer waxing and hair-removal
          services to both sexes. Our services take place in a safe and private
          environment that makes every visitor feel welcome and comfortable,
          irrespective of age or body type.
          <br />
          <br />
          <span style={{ display: "block" }}>
            We are aware that that waxing can make one feel uncomfortable for
            the first time, especially for men. For this reason, our staff first
            works on making visitors feel relaxed with the right conversation
            while explaining everything later. Their work is also just as
            gentle...
          </span>
          <br />
          <span style={{ display: "block" }}>
            Looking for <b> Male Full Body Waxing in Pune?</b> We are the right
            place. Men visit us for full body wax for men in large numbers,
            especially athletes, gym-goers, and professionals who want to look
            their best at all times and settings.
          </span>
          <br />
          <span style={{ display: "block" }}>
            For ladies, we offer all the services from waxing arms and legs to
            <b> Full Body Bikini Wax</b> and more. We are known among ladies of
            a certain class for clean, careful, and respectful service when it
            is about <b>Full Body Waxing for Women.</b>
          </span>
        </p>

        <h2>What to Expect</h2>
        <ul className="cupping-checklist">
          <p style={{ fontWeight: "bold" }}>Here’s how it works:</p>
          <li>We talk to you and understand which areas you want waxed</li>
          <li>
            We clean the skin and apply warm wax (we use soft or hard wax
            depending on your skin type)
          </li>
          <li>We gently remove the hair in a quick, clean way</li>
          <li>We apply a soothing gel to calm the skin after the wax</li>
          <p>
            The whole process takes about 45 to 90 minutes, depending on how
            much hair you have and your skin type. In the end, you go back
            feeling incredibly light, clean and confident.
          </p>
        </ul>

        <h2>Is Full Body Waxing Right for You?</h2>
        <ul className="cupping-checklist">
          <p style={{ fontWeight: "bold" }}>Yes, if you:</p>
          <li>Feel tired of shaving every few days</li>
          <li>Want smoother skin that lasts longer</li>
          <li>Have a special event like a wedding or a trip</li>
          <li>Want to feel confident and happy visiting the beach or a gym</li>
          <li>Just want to treat yourself and feel fresh!</li>
          <p>
            We've helped hundreds of people across Pune feel more confident and
            cleaner with our waxing services — and we can do the same for you.
          </p>
        </ul>

        <h2>Book Your Appointment Today</h2>
        <p>
          Don't wait to feel better in your own skin. At{" "}
          <b>Shrikrishna Arogyam</b>, we offer the best care for{" "}
          <b>Full Body Waxing</b>, no matter your gender or body type. We
          promise you privacy, comfort, and excellent results.
          <br />
          <span style={{ display: "block" }}>
            We welcome clients from into Kothrud, Karve Nagar, Deccan, Baner,
            Balewadi, Aundh, Panchvati, Wakad, Hinjewadi, Pimple Nilakh,
            Tathawade, Mahalunge, Sus, Pashan, Punawale, and PCMC — and we’d
            love to welcome you too.
          </span>
          <br />
          <span style={{ display: "block" }}>
            Call us now to book your body waxing session. Your smooth, clean
            look is just one step away.
          </span>
        </p>

        <BookingComponent />
      </Container>
    </div>
  );
};

export default WaxingServices;
